import React from 'react';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {AppState} from './store';
import Layout from './hoc/Layout/Layout';
import ItemDetails from './containers/products/ItemDetails/ItemDetails';


const App = () => {
  let routes;

  routes = (
      <Route
        exact
        path="/products/:id"
        component={ItemDetails}
      />
  );
  return <Layout>{routes}</Layout>;
};


const mapStateToProps = ({firebase}: AppState) => ({
  loggedIn: firebase.auth.uid,
  emailVerified: firebase.auth.emailVerified,
});

export default connect(mapStateToProps)(App);
